/* import __COLOCATED_TEMPLATE__ from './lsg-chip.hbs'; */
import Component from '@ember/component';

export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'div',
  classNames: ['LSG-c-chip']
});
